"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Rels_1 = require("../models/Rels");
const WmsRestClient_1 = __importDefault(require("../utils/WmsRestClient"));
class MasterAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            wmsRestClient = new WmsRestClient_1.default(billboardHost, s3BillboardUrl);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    async getThreeplGuidByTplId(tplId) {
        const tempMasterThreeplURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.MasterSvc.ThreePlSummaries);
        const masterThreeplURI = this._wmsRestClient.substituteValues(tempMasterThreeplURI.href, { rql: `threePlId==${tplId}` });
        const result = await this._wmsRestClient.get(masterThreeplURI);
        if (result?.ResourceList && result?.ResourceList.length > 0) {
            return result?.ResourceList[0].GuId;
        }
        return undefined;
    }
    async createApiCredential(body) {
        const rel = await this._wmsRestClient.billboardUri(Rels_1.Rels.MasterSvc.ApiCredentials);
        const uri = this._wmsRestClient.substituteValues(rel.href, {});
        const result = await this._wmsRestClient.post(uri, body);
        return result;
    }
}
exports.default = MasterAccessor;
